import Icon from "../Icon";
import PropTypes from "prop-types";
import InputNumber from "rc-input-number";
import React from "react";

import CloseIcon from "../CloseIcon";

import { segmentProps } from "./audienceProps";
import { className, styles } from "./audienceStyles";

export default class AudienceSegmentQuotaEditor extends React.PureComponent {
    static propTypes = {
        isReadOnly: PropTypes.bool.isRequired,
        segments: PropTypes.arrayOf(PropTypes.shape(segmentProps)).isRequired,
        onClose: PropTypes.func.isRequired,
        onSegmentQuotaChange: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.onSegmentQuotaChange = this.onSegmentQuotaChange.bind(this);
    }

    onSegmentQuotaChange(segment, value) {
        if (this.props.isReadOnly) {
            return;
        }

        // The InputNumber component will increment by step*10 if you hold
        // shift, which is a nice (if hard to discover) feature. However, it
        // will also increment by step/10 if you hold the "meta" key, which
        // means we can get fractional percentages. I'm going to round those
        // to the nearest integer, which should effectively disable the meta
        // key.
        const roundedValue = Math.round(value);
        this.props.onSegmentQuotaChange(segment, roundedValue);
    }

    render() {
        const selectedSegments = this.props.segments.filter(
            segment => segment.isSelected
        );

        const total = selectedSegments.reduce(
            (tot, seg) => tot + (seg.percentage || 0),
            0
        );
        const totalClassName = className(
            "total",
            total === 100 ? "valid" : "invalid"
        );

        const disabled = this.props.isReadOnly || selectedSegments.length === 1;

        const inputs = selectedSegments.map(segment => (
            <div key={segment.id} className={styles.segment}>
                <label
                    className={styles.segmentLabel}
                    htmlFor={`segment-${segment.id}`}
                >
                    {segment.label}
                </label>
                <InputNumber
                    id={`segment-${segment.id}`}
                    disabled={disabled}
                    value={segment.percentage || 0}
                    formatter={v => (v ? `${v}%` : "")}
                    min={0}
                    max={100}
                    step={1}
                    onChange={value =>
                        this.onSegmentQuotaChange(segment, value)
                    }
                />
            </div>
        ));

        return (
            <div className={styles.quotaEditor}>
                <div className={styles.header}>
                    <p className={styles.headerText}>
                        <Icon
                            className={styles.icon}
                            icon="chart-pie"
                        />
                        <span className={styles.title}>
                            {this.props.isReadOnly
                                ? "View Quotas"
                                : "Edit Quotas"}
                        </span>
                        <span {...totalClassName}>Total: {total}%</span>
                    </p>
                    <div className={styles.actions}>
                        <button
                            type="button"
                            className={styles.actionButton}
                            onClick={this.props.onClose}
                        >
                            <CloseIcon className={styles.close} />
                        </button>
                    </div>
                </div>
                <form className={styles.quotaForm}>{inputs}</form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/AudienceSegmentQuotaEditor.js